@defer (when claim) {
    <div class="container form-container">
        <div class="card">
            <div class="card-body">
                <!-- @if (claim) { -->
                <div class="row mb-3 section-row">
                    <div class="col-12">
                        <div class="section-heading mb-4">
                            <span>Upload physician form for:&nbsp;{{ claim.accountStudent?.firstName }}&nbsp;{{ claim.accountStudent?.lastName }}</span>
                        </div>
                        <p>Upload completed physician claim form. The form is to be completed and signed by the physician.</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <app-upload-file [allowedTypes]="allowedTypes" [maxFiles]="maxFileUpload" (filesChanged)="onFilesChanged($event)"></app-upload-file>
                    </div>
                </div>
                <div class="row mt-5">
                    <!-- Standard desktop layout preserved at 768+ -->
                    <div class="col-6 d-none d-md-block">
                        <button type="button" class="btn btn-outline-primary" (click)="onPreviousPage()">
                            <i class="fa-solid fa-chevron-left me-3"></i>
                            <span class="btn-text">Back</span>
                        </button>
                    </div>
                    <div class="col-6 d-none d-md-block text-end">
                        <button
                            type="button"
                            class="btn btn-primary"
                            (click)="uploadPhysicianForm()"
                            [disabled]="selectedFiles.length === 0 || isUploading"
                            [class.btn--waiting]="isUploading">
                            <span class="btn-text">Upload physician form</span>
                            <i class="fa-solid fa-arrow-up-from-bracket ms-3"></i>
                        </button>
                    </div>

                    <!-- Mobile-only stacked buttons (full width) -->
                    <div class="col-12 d-md-none">
                        <div class="d-grid gap-4">
                            <button type="button" class="btn btn-outline-primary" (click)="onPreviousPage()">
                                <i class="fa-solid fa-chevron-left me-3"></i>
                                <span class="btn-text">Back</span>
                            </button>
                            <button
                                type="button"
                                class="btn btn-primary"
                                (click)="uploadPhysicianForm()"
                                [disabled]="selectedFiles.length === 0 || isUploading"
                                [class.btn--waiting]="isUploading">
                                <span class="btn-text">Upload physician form</span>
                                <i class="fa-solid fa-arrow-up-from-bracket ms-3"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
} @placeholder {
    <div class="container mt-4">
        <div class="row text-center">
            <div class="col-12 heading-md pb-2">One moment...</div>
        </div>
    </div>
}
